import React from "react";
import { Button } from '@chakra-ui/react';

import { Box, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { GoKebabHorizontal } from "react-icons/go";
import { displayReactIcon } from "../helpers/dsr-display-helpers";
import LaunchdeckTag from "../../global/components/helper-components/components/LaunchdeckTag";


export default function DsrMessageOptionsButton({
  onClickDeleteMessageOption,
  confirmationType,
  postId,
  isPostAuthor,
  handleChangeUserActionRequired,
  dsrId,
  isDsrAdmin,
  postObject
}) {
  
  const renderOptions = () => {
    const handleReportPost = () => {
      handleChangeUserActionRequired('report-updates-post', {
        dsrId,
        postId,
      })
    }

    const handleEditPost = () => {
      handleChangeUserActionRequired("edit-dsr-message-post", {
        postIdToEdit: postId, 
        postObject: postObject,
        userActionRequired:'edit-dsr-message-post'
       })
    }

    if (isPostAuthor) {
      const {postType} = postObject || {}
      const showEditOption = (postType !== "loom-video-post")
      
      return (
        <>
          {showEditOption && <MenuItem name='showEditPostModal' className='filter-menu__dropdown-option-display' onClick={() => handleEditPost()}  > {displayReactIcon("edit", "1em")} Edit post</MenuItem>}
          <MenuItem name='showDeletePostModal' className='filter-menu__dropdown-option-display' onClick={() => onClickDeleteMessageOption({ postId }, confirmationType)}> {displayReactIcon("remove-post", "1em")} Delete post</MenuItem>
        </>
      )
    } else {
      return (
        <>
          {isDsrAdmin ?
            <MenuItem name='showDeletePostModal' className='filter-menu__dropdown-option-display' onClick={() => onClickDeleteMessageOption({ postId }, confirmationType)}> 
            <span><LaunchdeckTag bg='brandGreen.500' py='0em' color='white' reactIcon={"mod-action"} label='MOD'/></span>Delete post</MenuItem>
            :
            <MenuItem name='showReportPostModal' className='filter-menu__dropdown-option-display' onClick={() => handleReportPost()}> {displayReactIcon("report", "1em")} Report post</MenuItem>
          }
        </>
      )
    }
  }

  return (
    <React.Fragment>
      <Menu closeOnSelect={true} >
        <MenuButton as={Button} rounded='0.25em' bg='white' px='1em' ml='2em'>
          <Box as={GoKebabHorizontal} boxSize="2.5rem" py='3%' />
        </MenuButton>
        <MenuList zIndex={2} minWidth="10em" fontSize='0.875em'>
          {renderOptions()}
        </MenuList>
      </Menu>
    </React.Fragment>
  );
}
